import { Pipe, PipeTransform } from '@angular/core';
import { DateService } from '../services/date.service';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'dateFormat'
})
export class DatePipe implements PipeTransform {

  constructor(private dateService: DateService, public translateService: TranslateService) {}

  transform(date, textWithTime = false, nearDate = true) {
    const language = this.translateService.currentLang ? this.translateService.currentLang : this.translateService.defaultLang;
    if (language.toUpperCase() == "ES") {
       return this.dateService.formatDate(date, "DD/MM/YYYY", textWithTime, nearDate);
    }
    if (language.toUpperCase() == "EN") {
       return this.dateService.formatDate(date, "MM/DD/YYYY", textWithTime, nearDate);
    }
 }
}
